<template>
<nav id="sidebar">
    <!-- <div class="sidebar-header"></div> -->
    <ul class="list-unstyled components">
        <li class="active" style="background-color: #fff">
            <a href="" style="padding:5px">
                <img src="../../assets/img/end_tb_logo.png" height="50px" width="50px">
            </a>
        </li>
        <router-link class="overview" to="/overview">
            <li class="active">
                <a href="#">
                    <img src="../../assets/img/Overview.png">
                    {{ $t("Sidebar.overview") }}
                </a>
            </li>
        </router-link>
        <router-link class="pathway" to="/pathway">
            <li>
                <a href="#">
                    <img src="../../assets/img/analysis.png">
                    Pathway
                </a>
            </li>
        </router-link>
        <router-link class="anylasis" to="/anylasis">
            <li>
                <a href="#">
                    <img src="../../assets/img/analysis.png">
                    {{ $t("Sidebar.analysis") }}
                </a>
            </li>
        </router-link>
        <router-link class="maps" to="/maps">
            <li>
                <a href="#">
                    <img src="../../assets/img/map.png">
                    {{ $t("Sidebar.map") }}
                </a>
            </li>
        </router-link>
        <router-link class="alerts" to="/alerts">
            <li>
                <a href="#">
                    <img src="../../assets/img/alert.png">
                    {{ $t("Sidebar.alert") }}
                </a>
            </li>
        </router-link>
        <!-- <li>
                <a href="#" >
                    <img src="../../assets/img/contactregister.png">
                    Contact registered patient
                </a>
            </li> -->
        <router-link class="lineList" to="/lineList">
            <li>
                <a href="#">
                    <img src="../../assets/img/linelist.png">
                    {{ $t("Sidebar.linelist") }}
                </a>
            </li>
        </router-link>
        <!-- <router-link to="/upload">
            <li>
                <a href="javascript:void(0)">
                    <img src="../../assets/img/file.svg" style="width: 35px;">
                Registered Cases Upload
                </a>
            </li>
        </router-link> -->
    </ul>
</nav>
</template>

<script>
export default {
    data() {
        return {
            userData: JSON.parse(sessionStorage.getItem("userData")),
            logoUrl: ''
        }
    },
    methods: {
        logOut() {
            sessionStorage.removeItem('userData')
            this.$router.push('/')
        }
    },
    mounted() {
        let langLocal = JSON.parse(sessionStorage.getItem('langLocal'))
        for(let lang in langLocal){
            console.log(lang, langLocal[lang])
            this.$i18n.setLocaleMessage(lang,langLocal[lang])
        }
        this.logoUrl = '/' + this.userData.programlogo
    }
}
</script>
